import React, { useState } from 'react';
import './orderTable.scss';
import OrderTableCell from '../OrderTableCell/OrderTableCell';
import TableBtn from '../TableBtn/TableBtn';
import { useContent, useLanguages } from '../../hooks/content';
import { Returntext } from '../../pages/Landings/common/returnText';
import OrderPopOver from '../../components/atoms/OrderPopOver/OrderPopOver';
import { BrowserView } from 'react-device-detect';
import { ReactComponent as CompleteIcon } from '../../icons/complete.svg';
import { ReactComponent as CompleteDisabledIcon } from '../../icons/complete-d.svg';
import { ReactComponent as DeclareIcon } from '../../icons/declare.svg';
import { ReactComponent as TrackingIcon } from '../../icons/tracking.svg';
import { ReactComponent as TrackingDisabledIcon } from '../../icons/tracking-d.svg';
import { ReactComponent as CustomIcon } from '../../icons/custom-tb.svg';
import { ReactComponent as CustomDisabledIcon } from '../../icons/custom-d.svg';
import { ReactComponent as DeliveryIcon } from '../../icons/delivery-tb.svg';
import { ReactComponent as DeliveryDisabledIcon } from '../../icons/delivery-d.svg';
import { ReactComponent as PayIcon } from '../../icons/pay.svg';
import { ReactComponent as PayIcon2 } from '../../icons/pay2.svg';

import { ReactComponent as PayDisabledIcon } from '../../icons/pay-disable.svg';
import { useDispatch } from 'react-redux';
import {
  setB2BDrawerStep1,
  setB2BDrawerStep2,
  setB2BDrawerStep3,
} from '../../redux/actions';

const OrderTable = ({
  orders,
  declareClick,
  setActiveOrder,
  customClick,
  paymentClick,
  deliveryClick,
  trackingWayClick,
  vatClick,
  setDeleteOrder,
  setActiveItem,
  payedClick,
}) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();
  const dispatch = useDispatch();

  const payTxt = (order) => {
    if (
      order?.buttons?.payment_enable ||
      order?.buttons?.is_payment_invoice_enabled
    ) {
      if (order?.payments[0]?.status === 'PENDING') {
        return `${Returntext(contentManagementData, 'processing_dash', lang)}`;
      } else {
        return `${Returntext(
          contentManagementData,
          'btn_pay',
          lang,
        )} ₾${order.prices.total.toFixed(2)}`;
      }
    } else if (!order?.buttons?.payment_enable && order?.payed) {
      return Returntext(contentManagementData, 'btn_payed', lang);
    } else {
      return Returntext(contentManagementData, 'btn_pay', lang);
    }
  };

  const getCount = (count) => {
    if (count === '1') {
      return '1';
    } else if (count === '2' || count === '3') {
      return '2';
    } else if (count === '4' || count === '5') {
      return '3';
    }
  };

  // Define the function outside your component or within it as needed
  const handleOrderPayClick = (order) => {
    // Set the active order
    setActiveOrder(order);

    // Destructure required properties from order.buttons safely
    const {
      payment_enable,
      is_payment_invoice_enabled,
      payment_invoice_status,
    } = order?.buttons || {};
    console.log(order?.buttons);
    // Case 1: payment_enable true and is_payment_invoice false
    if (payment_enable && payment_invoice_status === 'NOT INVOICE') {
      paymentClick();
    }
    // Case 2: payment_enable false and is_payment_invoice false
    else if (
      !payment_enable &&
      !is_payment_invoice_enabled &&
      payment_invoice_status === 'NOT INVOICE'
    ) {
      payedClick();
    } else if (
      (!payment_enable &&
        !is_payment_invoice_enabled &&
        payment_invoice_status === 'COMPLETED') ||
      payment_invoice_status === 'REFUNDED'
    ) {
      dispatch(setB2BDrawerStep3(true));
    }
    // Case 3: Invoice enabled scenario
    else if (is_payment_invoice_enabled) {
      switch (payment_invoice_status) {
        case null:
        case undefined:
          paymentClick();
          break;
        case 'PENDING':
          dispatch(setB2BDrawerStep2(true));
          break;
        case 'PENDINGONUSER':
          dispatch(setB2BDrawerStep1(true));
          break;
        case 'REJECTED':
          paymentClick();
          break;
        default:
          console.warn(
            'Unhandled payment_invoice_status:',
            payment_invoice_status,
          );
      }
    }
  };
  return (
    <div className="order-table">
      {orders.map((order) => (
        <OrderTableCell
          order={order}
          key={order.id}
          setActiveItem={setActiveItem}
          setDeleteItem={setDeleteOrder}
          buttons={
            <>
              <TableBtn
                mode=""
                mainColor="grayBorder"
                txt={Returntext(contentManagementData, 'btn_declare', lang)}
                disabled={false}
                icon={true}
                iconLeft={true}
                iconRight={order.declaration_status === 'DECLERED'}
                rightSvg={<CompleteIcon />}
                rightSvgDisabled={<CompleteDisabledIcon className="icon" />}
                svg={<DeclareIcon />}
                onClick={() => {
                  setActiveOrder(order);
                  declareClick();
                }}
              />
              <TableBtn
                mode=""
                mainColor="grayBorder"
                txt={Returntext(contentManagementData, 'btn_tracking', lang)}
                disabled={order.status === 'AWAITING'}
                icon={true}
                iconLeft={true}
                iconRight={!!order.delivery_status}
                rightSvg={<CompleteIcon className="icon" />}
                rightSvgDisabled={<CompleteDisabledIcon className="icon" />}
                svg={<TrackingIcon className="icon" />}
                svgDisabled={<TrackingDisabledIcon className="icon" />}
                onClick={() => {
                  setActiveOrder(order);
                  trackingWayClick();
                }}
              />
              <TableBtn
                mode=""
                mainColor="grayBorder"
                txt={Returntext(contentManagementData, 'btn_custom', lang)}
                disabled={!order?.buttons?.custom_enable}
                icon={true}
                iconLeft={true}
                iconRight={order?.buttons?.custom_right_icon_enable}
                rightSvg={<CompleteIcon className="icon" />}
                rightSvgDisabled={<CompleteDisabledIcon className="icon" />}
                svg={<CustomIcon className="icon" />}
                svgDisabled={<CustomDisabledIcon className="icon" />}
                rightDoubleIcon={
                  order?.buttons?.custom_right_double_icon_enable
                }
                onClick={() => {
                  if (order.vat) {
                    setActiveOrder(order);
                    vatClick();
                  } else {
                    setActiveOrder(order);
                    customClick();
                  }
                }}
                count={getCount(order?.custom_status)}
              />
              <TableBtn
                mode=""
                mainColor="grayBorder"
                txt={Returntext(contentManagementData, 'btn_delivery', lang)}
                disabled={!order?.buttons?.delivery_enable}
                icon={true}
                iconLeft={true}
                iconRight={!!order.timeSlot}
                rightSvg={<CompleteIcon className="icon" />}
                rightSvgDisabled={<CompleteDisabledIcon className="icon" />}
                svg={<DeliveryIcon className="icon" />}
                svgDisabled={<DeliveryDisabledIcon className="icon" />}
                onClick={() => {
                  setActiveOrder(order);
                  deliveryClick();
                }}
              />
              <TableBtn
                fullWidth={true}
                mode=""
                mainColor={
                  order?.prices?.total && !order.payed ? 'red' : 'grayBorder'
                }
                txt={payTxt(order)}
                disabled={
                  order?.buttons?.payment_enable ||
                  order?.payed ||
                  order?.buttons?.is_payment_invoice_enabled
                    ? false
                    : true
                }
                svg={
                  !!order.payed ? (
                    <PayIcon2 className="icon" />
                  ) : (
                    <PayIcon className="icon" />
                  )
                }
                svgDisabled={<PayDisabledIcon className="icon" />}
                icon={true}
                iconLeft={true}
                iconRight={!!order.payed}
                rightSvg={<CompleteIcon className="icon" />}
                rightSvgDisabled={<CompleteDisabledIcon className="icon" />}
                onClick={() => handleOrderPayClick(order, setActiveOrder)}
              />
              <BrowserView>
                {order.status === 'AWAITING' && (
                  <OrderPopOver
                    item={order}
                    setActiveItem={setActiveItem}
                    setDeleteItem={setDeleteOrder}
                  />
                )}
              </BrowserView>
            </>
          }
        />
      ))}
    </div>
  );
};

export default OrderTable;
